// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.

import { CustomEvent } from "../../Utils/CustomEvents.ts";
import { ButtonTemplate } from "../../templates.js";
import { Control } from "./Control.js";

export let TerceraButton = Control.extend({

    template: ButtonTemplate,
    data: function ()
    {
        return {
            text: '',
            terceraButtonStyle: 'js-button-gray25',

            height: 25,
            zIndex: null,

            // сейчас картинка только без текста и только по центру!
            image: '', // url
            imageChecked: '',
            images: null,

            checked: false,
            canCheck: false,
            tag: null,
            localizeKey: '',

            isColoringButton: false,
            coloringButtonImage: '',
            coloringButtonColor: 'rgb(0,0,0)',

            counter: 0,                             // counter value, also visibile indicator -> if counter>0 than it is visible
            counterStyle: 'circle-counter',         // adding '-plus' to style's name for counter > 99
            counterIsHiddenWhileBlinking: false,    // to make blinking counter

            isRelative: false
        };
    },
    onClick: null,
    btnInGroup: false,
    lastMouseClickX: 0,
    lastMouseClickY: 0,
    blinkIntervalFrequency: 720, // (milliseconds)  for btn's counter blinking
    blinkIntervalID: null        // blink set interval holder
});

TerceraButton.prototype.getType = function () { return 'TerceraButton' };

TerceraButton.prototype.oninit = function ()
{
    Control.prototype.oninit.apply(this);
    this.on('componentOver', this.private_MouseOver);
    this.on('componentClick', this.private_MouseClick);
    this.onClick = new CustomEvent();
};

//
//
//
TerceraButton.prototype.private_MouseClick = function (e)
{
    if (e && e.original)
    {
        this.lastMouseClickX = e.original.clientX;
        this.lastMouseClickY = e.original.clientY;
    }

    var canCheck = this.get('canCheck');
    var checked = this.get('checked');

    if (!this.get('enabled'))
        return;

    if (canCheck)
    {
        if (this.btnInGroup && checked)
            ;
        else
            this.set('checked', !checked);
    }


    this.fire(TerceraButton.Events.onClick, this);
    this.onClick.Raise(this, this);
};

TerceraButton.prototype.Click = function ()
{
    this.private_MouseClick(this);
}

TerceraButton.prototype.private_MouseOver = function (event)
{
    // this.stopCounterBlinking() // not in use functionality

    this.fire(TerceraButton.Events.onHover, event);
}

TerceraButton.prototype.startCounterBlinking = function ()
{
    this.stopCounterBlinking()     // stop old setInterval

    this.blinkIntervalID = setInterval(function ()
    {
        this.set('counterIsHiddenWhileBlinking', !this.get('counterIsHiddenWhileBlinking'))
    }.bind(this), this.blinkIntervalFrequency);
}

TerceraButton.prototype.stopCounterBlinking = function ()
{
    this.set('counterIsHiddenWhileBlinking', false)

    if (this.blinkIntervalID)
        clearInterval(this.blinkIntervalID)
}
//
//
//
TerceraButton.prototype.setImages = function (newDefaultImageUrl, newHoverImageUrl, newClickImageUrl, newDisabledImageUrl, newCheckedImageUrl)
{
    var newImages = {
        defaultImageUrl: newDefaultImageUrl,
        hoverImageUrl: newHoverImageUrl,
        clickImageUrl: newClickImageUrl,
        disabledImageUrl: newDisabledImageUrl,
        checkedImageUrl: newCheckedImageUrl
    };

    this.set({ images: newImages });
};

TerceraButton.prototype.getContextMenuItem = function () {
    const contextMenuItem = Control.prototype.getContextMenuItem.call(this);
    contextMenuItem.tag = this.get('tag');
    contextMenuItem.style = this.get('terceraButtonStyle');
    contextMenuItem.enabled = this.get('enabled');
    contextMenuItem.canCheck = this.get('canCheck');
    contextMenuItem.checked = this.get('checked');
    contextMenuItem.event = this.Click.bind(this);
    return contextMenuItem;
}

//
//
//
TerceraButton.TerceraButtonStyle =
{
    Standard: 'js-button-gray25',
    Toolbar: 'js-toolbarbutton-gray21',
    Blue: 'js-button-blue25',
    BlueClose: 'js-button-blueClose',
    Buy: 'js-button-buy25',
    Sell: 'js-button-sell25',

    BorderLess: 'js-borderless-imagesbutton',

    ///used in new Style
    Terminal: 'js-button-terminal',
    ColorPicker: 'js-colorpickerbutton',
};
Object.freeze(TerceraButton.TerceraButtonStyle);

//
//
//
TerceraButton.Events =
{
    onClick: 'btnClick',
    onHover: 'btnHover'
};
Object.freeze(TerceraButton.Events);